import { createContext, useContext, useState, useEffect } from 'react';
import { travellerFeedbackService } from '../../services/travellerFeedback/travellerFeedbackService';

const TravellerFeedbackContext = createContext();

export const useTravellerFeedback = () => useContext(TravellerFeedbackContext);
// Backward compatibility alias
export const useFeedback = useTravellerFeedback;

export const TravellerFeedbackProvider = ({ children }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [statistics, setStatistics] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFeedback, setSelectedFeedback] = useState(null);

  const getAgentId = () => {
    return localStorage.getItem('agent_id');
  };

  const fetchFeedbacks = async () => {
    const agentId = getAgentId();
    if (!agentId) {
      setError('Agent ID not found. Please login again.');
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const data = await travellerFeedbackService.getFeedbacks(agentId);
      if (data.success) {
        setFeedbacks(data.data?.feedback || []);
      } else {
        setError(data.message || 'Failed to fetch feedback');
      }
    } catch (err) {
      console.error('Failed to fetch feedback', err);
      setError(err.message || 'Failed to fetch feedback');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStatistics = async () => {
    const agentId = getAgentId();
    if (!agentId) return;

    try {
      const data = await travellerFeedbackService.getFeedbackAnalytics(agentId);
      if (data.success) {
        setStatistics(data.data || {});
      }
    } catch (err) {
      console.error('Failed to fetch statistics:', err);
    }
  };

  const refreshAll = () => {
    fetchFeedbacks();
    fetchStatistics();
  };

  useEffect(() => {
    const token = localStorage.getItem('token_agents');
    const isAuthPage = window.location.pathname === '/login' || window.location.pathname === '/signup';
    if (token && !isAuthPage) {
      refreshAll();
    }
  }, []);

  const value = {
    feedbacks,
    statistics,
    isLoading,
    error,
    selectedFeedback,
    setSelectedFeedback,
    fetchFeedbacks,
    fetchStatistics,
    refreshAll
  };

  return (
    <TravellerFeedbackContext.Provider value={value}>
      {children}
    </TravellerFeedbackContext.Provider>
  );
};

// Backward compatibility alias
export const FeedbackProvider = TravellerFeedbackProvider;

export default TravellerFeedbackContext;
